import FlipInfoIcon from './FlipInfoIcon'

// Row primitive: label at content-left, children right-aligned, 32px rhythm. `relative` lets
// FlipInfoIcon's tooltip anchor to this row, not the icon -- see FlipInfoIcon.jsx. Classes written
// in full, not `font-${weight}` (the interpolation trap IncludedExcludedToggle.jsx documents).
const LABEL_CLS = {
  normal: 'text-[14px] font-normal text-brand-dark',
  bold: 'text-[14px] font-bold',
}

// `control` sits beside the label (dropdown, toggle, disclosure) -- its x position tracks the
// label's own width, unlike `children` (the value box(es)), which stay flush to the value column.
// Conflating the two put every control at a constant value-column x regardless of label width,
// measured up to 144px off the drawn position -- see README.md ("control belongs beside the label").
export default function FieldRow({ label, tooltip, control, weight = 'normal', color = 'text-brand-dark', children }) {
  const labelCls = weight === 'bold' ? `${LABEL_CLS.bold} ${color}` : LABEL_CLS.normal
  return (
    <div className="relative flex flex-wrap items-center min-h-[32px] gap-y-[4px]">
      <span className="inline-flex items-center gap-x-[6px]">
        <span className={labelCls}>{label}</span>
        {tooltip ? <FlipInfoIcon tooltip={tooltip} /> : null}
        {control}
      </span>
      {/* `ml-auto`, not the parent's `justify-between`: on a row narrow enough to wrap, the value
          column lands on its own flex line, where `justify-between` (a property of the row with two
          items on ONE line) no longer has anything to distribute -- the column then defaults to the
          start of its own line, losing right alignment while unwrapped rows in the same card keep
          it. `margin-left: auto` pushes this span to the end of whichever line it occupies, wrapped
          or not, keeping every row's value column right-aligned consistently -- the alignment the
          design does specify, even though the design draws nothing below 1440. */}
      <span className="ml-auto inline-flex items-center gap-x-[6px]">{children}</span>
    </div>
  )
}
